import classNames from 'classnames';

import Icon from '../../../app/shared/components/Icon/Icon';
import Link from '../../../app/shared/components/Link';
import { RelativeUrl } from '../../../app/shared/Url';
import css from './TopBar.css';

interface TopBarProps {
  children: React.ReactNode;
  className?: string;
}

export const TopBar = ({ children, className }: TopBarProps) => {
  return <div className={classNames(css.root, className)}>{children}</div>;
};

interface TopBarActionsProps {
  children: React.ReactNode;
}

export const TopBarActions = ({ children }: TopBarActionsProps) => {
  return <div className={css.actions}>{children}</div>;
};

interface BacklinkProps {
  children: React.ReactNode;
  to: RelativeUrl;
}

export const Backlink = ({ children, to }: BacklinkProps) => {
  return (
    <Link className={css.backlink} to={to}>
      <Icon name="arrowBack" className={css.backlinkIcon} /> {children}
    </Link>
  );
};
